var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F9FBF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3542 29C18.0593 29.6224 18.9856 30 20 30C21.0145 30 21.9407 29.6224 22.6458 29M26 16C26 14.4087 25.3679 12.8826 24.2427 11.7574C23.1174 10.6321 21.5913 10 20 10C18.4087 10 16.8826 10.6321 15.7574 11.7574C14.6322 12.8826 14 14.4087 14 16C14 19.0902 13.2205 21.206 12.3497 22.6054C11.6151 23.7859 11.2479 24.3761 11.2613 24.5408C11.2763 24.7231 11.3149 24.7926 11.4618 24.9016C11.5945 25 12.1926 25 13.3889 25H26.6112C27.8074 25 28.4056 25 28.5382 24.9016C28.6852 24.7926 28.7238 24.7231 28.7387 24.5408C28.7522 24.3761 28.3849 23.7859 27.6504 22.6054C26.7795 21.206 26 19.0902 26 16Z",
    stroke: "#D97706",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.28aa38d50181b99412f659172b56078c.svg";
export { ForwardRef as ReactComponent };